<template>
  <div class="max-w-4xl px-4 py-12 mx-auto">
    <div class="p-8 border shadow-2xl bg-gray-900/80 backdrop-blur-lg border-gray-800/50 rounded-3xl animate-fade-in-up">
      <h1 class="mb-8 text-4xl font-bold text-white">{{ $t('footer.legal.terms') || 'Terms of Service' }}</h1>
      
      <div class="space-y-6 leading-relaxed text-gray-300">
        <p>These terms and conditions outline the rules and regulations for the use of Barbers Unity's Website.</p>
        
        <h2 class="mt-8 text-2xl font-semibold text-white">1. Terms</h2>
        <p>By accessing this website, you are agreeing to be bound by these website Terms and Conditions of Use, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this site.</p>
        
        <h2 class="mt-8 text-2xl font-semibold text-white">2. Use License</h2>
        <p>Permission is granted to temporarily download one copy of the materials (information or software) on Barbers Unity's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:</p>
        <ul class="pl-6 space-y-2 list-disc">
          <li>modify or copy the materials;</li>
          <li>use the materials for any commercial purpose, or for any public display (commercial or non-commercial);</li>
          <li>attempt to decompile or reverse engineer any software contained on Barbers Unity's website;</li>
          <li>remove any copyright or other proprietary notations from the materials.</li>
        </ul>

        <h2 class="mt-8 text-2xl font-semibold text-white">3. Disclaimer</h2>
        <p>The materials on Barbers Unity's website are provided on an 'as is' basis. Barbers Unity makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</p>
        
        <h2 class="mt-8 text-2xl font-semibold text-white">4. Limitations</h2>
        <p>In no event shall Barbers Unity or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Barbers Unity's website.</p>
      </div>

      <div class="mt-10">
        <button @click="$router.back()" class="flex items-center gap-2 px-6 py-2.5 text-sm font-semibold text-white transition-all duration-300 bg-gray-800 border border-gray-700 rounded-xl hover:bg-gray-700 hover:-translate-y-0.5 shadow-lg">
          <i class="fa fa-arrow-left"></i> {{ $t('previous') || 'Back' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsView'
}
</script>